import { IonButton, IonContent, IonIcon, IonPage } from "@ionic/react";
import { cameraOutline } from "ionicons/icons";
import "../theme/Instructions.css";
import "../theme/Utilities.css";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { Granted, Permissions } from "../components/Permissions";
import PoseOverlay from "../components/PoseOverlay";
const FrontPosePage: React.FC = () => {
  const history = useHistory();
  const { profileID, sessionID, gender } = useParams<{
    profileID: string;
    sessionID: string;
    gender: string;
  }>();
  const [permission, setPermission] = useState(false);
  useEffect(() => {}, [permission]);

  return (
    <IonPage>
      <IonContent>
        <Permissions
          updated={(granted: Granted) => setPermission(granted.gyro)}
        ></Permissions>
        {permission && (
          <>
            <div className="flex items-center justify-center mt-16">
              {/*  <img
                src={image}
                alt="Person in an A-pose"
                className="max-h-[70vh] max-w-full w-auto h-auto"
              /> */}
              <PoseOverlay view="front" />
            </div>

            <div className="buttonsUnderInstructions">
              <IonButton
                size="large"
                fill="outline"
                onClick={() => history.push(`/photo/${profileID}/${sessionID}/${gender}/front`)}
              >
                Open camera <IonIcon icon={cameraOutline} />
              </IonButton>
            </div>
          </>
        )}
      </IonContent>
    </IonPage>
  );
};

export default FrontPosePage;
